import { render, staticRenderFns } from "./OverdueSummary.vue?vue&type=template&id=3803e3b4&scoped=true&"
import script from "./OverdueSummary.vue?vue&type=script&lang=js&"
export * from "./OverdueSummary.vue?vue&type=script&lang=js&"
import style0 from "./OverdueSummary.vue?vue&type=style&index=0&id=3803e3b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3803e3b4",
  null
  
)

export default component.exports